export default __webpack_public_path__ + "static/media/cs-gif4.ba58b152.gif";